export default __webpack_public_path__ + "static/media/ideas_4.3a6308a0.PNG";